import { ButtonBase } from "@material-ui/core";
import React from "react";
import "./footerStyle.css";

function DashboardFooter() {
  return (
    <div className="admin-footer-ls dashboard-footer d-flex justify-content-end align-items-center">
      <div className="left-side d-flex justify-content-center align-items-center">
        &copy; 2021 Ski Studio. All rights reserved
      </div>
      <div className="admin-footer-rs right-side d-flex justify-content-center align-items-center">
        <a
          href="/"
          onClick={() => {
            localStorage.removeItem("skiUserToken");
            window.location.reload();
          }}
        >
          Log out
        </a>
        <a href="/">Terms and Conditions</a>
        <a href="/">Privacy policy</a>
      </div>
    </div>
  );
}

export default DashboardFooter;
